module.exports = __webpack_public_path__ + "static/img/so4_6.8cfb9d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/solution/pic/so4_6.jpg
// module id = RNHk
// module chunks = 11